import React from 'react';
import { Link } from 'react-router-dom';
import { useExamType } from '../contexts/ExamTypeContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { getExamTypeName } = useExamType();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Leben in Deutschland Test</h3>
            <p>Your complete German citizenship test preparation companion</p>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/support">Support</Link>
            <Link to="/data-deletion">Data Deletion</Link>
          </div>
          <div className="footer-section">
            <h4>Features</h4>
            <span>300 Official Questions</span>
            <span>8 Languages Supported</span>
            <span>Mock Exams</span>
            <span>All 16 German States</span>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Leben in Deutschland Test Preparation. All rights reserved.</p>
          <p style={{fontSize: '0.85em', marginTop: '0.5rem', color: '#999'}}>
            Not affiliated with BAMF or any official German government agency.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

